import React from 'react';
import classNames from 'classnames';

import SectionContainer from '../SectionContainer';
import { MembershipBanner } from '../../../../components';

import css from './SectionMembershipBanner.module.css';

/**
 * PageBuilder section that renders the Ottawa–Rideau Lakes Membership banner.
 *
 * Synthetic — the operator doesn't create this in Sharetribe Console; the
 * LandingPage splices a `{ sectionType: 'membershipBanner' }` entry into the
 * fetched section array (just above the "Our Picks" section) and registers
 * this component via options.sectionComponents.
 *
 * The banner's content is hardcoded in <MembershipBanner /> (price tiers,
 * installment math, CTA). If/when you want the operator to edit copy from
 * Sharetribe Console, swap this for a real custom field section.
 */
const SectionMembershipBanner = props => {
  const { sectionId, className, rootClassName, appearance } = props;
  return (
    <SectionContainer
      id={sectionId}
      className={className}
      rootClassName={classNames(rootClassName || css.root)}
      appearance={appearance}
    >
      <MembershipBanner />
    </SectionContainer>
  );
};

export default SectionMembershipBanner;
